module.exports = __webpack_public_path__ + "static/media/nommin.f6e811e1.png";